import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/TorusKnotGeometry'

export default meshComponent('TorusKnot', props, createGeometry)
